import React from 'react';
import { Box } from '@mui/material';
import PropTypes from 'prop-types';
import { FormattedMessage, defineMessages ,useIntl } from 'react-intl';
import { Autocomplete, Checkbox, TextField, Option,Button, Typography, TextArea } from '@getgo/chameleon-web-react-wrapper';
import { AddOutlinedIcon } from '@getgo/chameleon-icons/react';
import classes from './role-list-view.scss';
import mt from 'core/message-translations';
import st from 'core/shared-translations';

const t = defineMessages({
  'role-management.input-field-id.helper-text': {
    id: 'role-management.input-field-id.helper-text',
    defaultMessage: 'Give the role a unique name to make it easier to identify.',
    description: 'Helper text for the ID input field'
  },
  'role.management.input-field-owner.helper-text': {
    id: 'role.management.input-field-owner.helper-text',
    defaultMessage: 'Select who you want to approve this role.',
    description: 'Helper text for the owner input field'
  },
});

const RoleDetails = ({
  isEditMode,
	role,
	onChange,
	onBlur,
	errors,
  autocompleteList,
  ownersList,
  autoCompleteRef,
  onClickAddOwner
	}) => {
	const intl = useIntl();
  //newautocompletelist contains ownerslist which is needed to be showed in Autocomplete when owners is already present
  // and also it contains role.approvers because so the it can accomodate new owners added which is not present in autocomplete list
  const newautocompleteList = [...new Set([...(autocompleteList || []), ...(ownersList || []), ...(role.approvers || [])])];
  return (
    <Box className={classes['roleDetailsContainer']}>
      <TextField
        id="id"
        name="name"
        role="textbox"
        value={role.id}
        title={intl.formatMessage(st["shared.role-management.input-field-id.title"])}
        onChange={onChange}
        onBlur={onBlur}
        error={
          (errors.id && (intl.formatMessage(st[errors.id] || mt[errors.id])))
        }
        disabled={isEditMode}
        fullwidth
        maxLength={50}
        helperText={
          (!isEditMode && (errors.id &&
              intl.formatMessage(st[errors.id] || mt[errors.id])) ||
          intl.formatMessage(t["role-management.input-field-id.helper-text"]))
        }
      >
        <FormattedMessage {...st["shared.role-management.input-field-id.title"]} />
      </TextField>
      <Autocomplete
        multiple
        onInput={onChange}
        onChange={onChange}
        id="approvers"
        ref={autoCompleteRef}
        label={intl.formatMessage(st['shared.role.management.input-field-owner.title'])}
        title={intl.formatMessage(st['shared.role.management.input-field-owner.title'])}
        helperText={(errors.approvers &&
          (intl.formatMessage(st[errors.approvers] || mt[errors.approvers]))) ||
          intl.formatMessage(t['role.management.input-field-owner.helper-text'])}
        fullWidth
        error={(errors.approvers && (intl.formatMessage(st[errors.approvers] || mt[errors.approvers])))}
        listboxStart={
          <Button
            variant="tertiary"
            leadingIcon={<AddOutlinedIcon />}
            onClick={onClickAddOwner}>
            <FormattedMessage {...st['shared.role.management.autocomplete.add.newowner']} />
          </Button>
        }>
        {newautocompleteList && newautocompleteList.map((item) => (
          <Option
            id={item}
            key={item}
            label={item}
            selected={ownersList?.includes(item) || role.approvers?.includes(item)}>
            <Typography>{item}</Typography>
          </Option>
        ))}
      </Autocomplete>
      <Checkbox
        id="active"
        label="active"
        onChange={onChange}
        checked={role.active}
      >
        <Typography data-testid="role-active-checkbox">
          <FormattedMessage {...st['shared.role.managment.active']} />
        </Typography>
      </Checkbox>
      <TextArea
        id="description"
        name="description"
        helpText=""
        resize="vertical"
        label={intl.formatMessage(st['shared.role.managment.description'])}
        onChange={onChange}
        value={role.description || ''}
        onBlur={onBlur}
        cols="40"
        rows="5"
        maxLength={500}
        cssClass="roleDescription"
        error={errors.description}
        fullwidth
      >
        <FormattedMessage {...st['shared.role.managment.description']} />
      </TextArea>
    </Box>
    );
};

RoleDetails.propTypes = {
  isEditMode: PropTypes.bool.isRequired,
  role: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired,
  onBlur: PropTypes.func.isRequired,
  errors: PropTypes.object.isRequired,
  autocompleteList: PropTypes.array,
  ownersList: PropTypes.array.isRequired,
  autoCompleteRef: PropTypes.object.isRequired,
  onClickAddOwner: PropTypes.func.isRequired,
};

export default RoleDetails;
